import {MediaRule} from '@packages/systems/style/style-sheets';
import {Breakpoint} from '@packages/systems/style/media-queries';
import type {BreakpointID} from '@packages/systems/style/types';

export function forEachTree<
  T extends {
    children: any;
  },
>(tree: T, f: (arg1: T) => void) {
  f(tree);
  if (tree.children) {
    // @ts-expect-error - TS7006 - Parameter 'child' implicitly has an 'any' type.
    tree.children.forEach((child) => forEachTree(child, f));
  }
}

export function createMediaRulesFromBreakpoints(
  breakpoints: Array<Breakpoint>
): Map<BreakpointID, MediaRule> {
  const rules = new Map();
  for (const bp of breakpoints) {
    rules.set(bp.id, new MediaRule(bp.queries, []));
  }
  return rules;
}
